import React, { useState } from 'react'
import ChaseModel from '../components/chase-model'
import QuestionList from '../components/question-list'
import CustomButton from '../components/custom-button'
import ChaseFileUploader from './chase-file-uploader'
import HelpCard from './help-card'
import ChaseInputItem from './chase-input-item'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/parse-errors'
import axiosInstance from '../utils/axiosInstance'
import UseChaseProvider from '../utils/use-chase-provider'

const ChaseLicenseQuestionCard: React.FC = () => {
    const { chase, chaseType, newFiles, onSetChaseType, driverId, onSetDriverId, isUploading } = UseChaseProvider()
    const [isDriverLicense, setDriverLicense] = useState<boolean | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(false)


    const onSubmitValues = async () => {
        setLoading(true)
        try {
            await axiosInstance.patch(`/chase/public/${chase?.policyReferenceNumber}`, {
                chaseType: chaseType,
                chaseBodyData: newFiles,
                chaseBodyDataType: "files",
                driverId
            })
            toast.success("Updated Successfully")
            setLoading(false)
            onSetChaseType()
            onSetDriverId()
        } catch (error) {
            toast.error(ParseErrors(error))
            setLoading(false)
        }
    }

    return (
        <ChaseModel>
            <div className={clsx("pb-6", isDriverLicense !== undefined && "border-b border-white/[0.12]")}>
                <QuestionList number={1} text="Do you have a UK Driver’s License?" >
                </QuestionList>
                <div className='w-full grid grid-cols-2 gap-3 mt-4 sm:pl-10' role='radiogroup'>
                    <CustomButton type='button' role='radio' aria-checked={isDriverLicense === true} variant={isDriverLicense === true ? "primary" : "outlined"} className={clsx('!h-[52px] !rounded-xl !text-[15px]', isDriverLicense !== true && '!bg-none !bg-app-row !border !border-white/10 !animate-none hover:!bg-[#16204A]')} onClick={() => setDriverLicense(true)}>Yes</CustomButton>
                    <CustomButton type='button' role='radio' aria-checked={isDriverLicense === false} variant={isDriverLicense === false ? "primary" : "outlined"} className={clsx('!h-[52px] !rounded-xl !text-[15px]', isDriverLicense !== false && '!bg-none !bg-app-row !border !border-white/10 !animate-none hover:!bg-[#16204A]')} onClick={() => setDriverLicense(false)}>No</CustomButton>
                </div>
            </div>


            {isDriverLicense === true && <div className='animate-drop-in'><ChaseInputItem /></div>}

            {isDriverLicense === false && <div className='animate-drop-in'>
                <div className='mt-6'>
                    <QuestionList number={2} text="Driver’s License Photo Copy" >
                    </QuestionList>
                </div>
                <div className='mt-4'>
                    <HelpCard />
                </div>
                <p className='mt-5 text-white/[0.66] text-[14px] leading-[21px]'>
                    Note: You can upload multiple files/images, up to 20 MB each. You can choose to take a new photo or upload a file or image below.
                </p>
                <div className='mt-5'>
                    <ChaseFileUploader />
                </div>

                <CustomButton disabled={!newFiles.length || isUploading} className='mt-6' onClick={onSubmitValues} loading={loading}>
                    Submit
                </CustomButton>
            </div>}
        </ChaseModel>
    )
}

export default ChaseLicenseQuestionCard
